import { InputAdornment, Tooltip } from '@mui/material';

export const InputErrorIcon = ({
  errorMessage,
}: {
  errorMessage?: React.ReactNode;
}) => {
  return (
    <InputAdornment position='start'>
      <Tooltip
        disableInteractive={false}
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: 'var(--mui-palette-error-main)',
              userSelect: 'text',
              cursor: 'text',
            },
          },
        }}
        title={errorMessage || 'Invalid input'}
      >
        <i className='material-symbols-error-outline-rounded bg-(--mui-palette-error-main)' />
      </Tooltip>
    </InputAdornment>
  );
};
